import "firebase/messaging";

import * as VueGoogleMaps from "vue2-google-maps";

import VeeValidate, { Validator } from "vee-validate";

import App from "./App";
import Axios from "axios";
import ClickOutside from "./directives/ClickOutside";
import Confirm from "./components/helper/dialog/Confirm";
import Croppa from "vue-croppa";
import { DateTime } from "luxon";
import { Picker } from "emoji-mart-vue";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueResource from "vue-resource";
import Vuex from "vuex";
import { baanRueJaiClient } from "./dependencies";
import firebase from "firebase/app";
import { formatToMoney, formatCurrencyAndTwoDecimalsString } from "./lib/formatter";
import i18n from "./setup/lang";
import lang from "element-ui/lib/locale/lang/th";
import locale from "element-ui/lib/locale";
import messageTH from "../node_modules/vee-validate/dist/locale/th";
import moment from "moment";
import router from "./router";
import { toLocaleTH } from "./lib/dateTime";
import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
import ElementUI from "element-ui";
import { getCookie, setCookie, Auth, unsetCookie } from "./lib/cookie";

locale.use(lang);

Vue.use(Vuex);
Vue.use(Croppa);
Vue.use(ElementUI);

Vue.mixin({
  computed: {
    $isCallCenter() {
      return +localStorage.getItem("adminRoleId") === 4;
    },
    $isAccounting() {
      return (
        JSON.parse(localStorage.getItem("adminRolePermission")).roleName ===
        "Accounting"
      );
    },
  }
});

// Setup FCM
try {
  if (firebase.messaging.isSupported()) {
    firebase.initializeApp({
      apiKey: "AIzaSyAnCSOpgNpVDuHorUWKWbaBlzjQuaCKkV4",
      projectId: "baanruejai-1749",
      messagingSenderId: "968668258607",
      appId: "1:968668258607:web:a2556aa321b43ba91e01da",
    });

    Vue.prototype.$messaging = firebase.messaging();
  }
} catch (error) {
  // console.log('Firebase not support for this browser. Please use Google Chrome latest version.', error);
}

Validator.localize("th", messageTH);
Vue.use(VeeValidate, {
  locale: "th"
});

export const store = new Vuex.Store({
  state: {
    sideBar: false,
    loader: false,
    projectId: localStorage.getItem("projectId"),
    projectName: localStorage.getItem("projectName"),
    projectIcon: localStorage.getItem("projectIcon")
  },
  mutations: {
    sideBarToggle: state => !state.sideBar,
    loaderStart(state) {
      state.loader = true;
    },
    loaderStop(state) {
      state.loader = false;
    },
    setProjectName(state, name) {
      state.projectName = name;
    },
    setProjectId(state, id) {
      state.projectId = id;
    }
  }
});

Axios.interceptors.request.use(config => {
  // Do something before request is sent
  store.commit("loaderStart");
  return config;
}, null);

Axios.interceptors.response.use(
  res => {
    store.commit("loaderStop");
    return res;
  },
  error => {
    store.commit("loaderStop");
    const isIidGoogleApisUrl = (url) => {
      try {
        return new URL(url).hostname == "iid.googleapis.com";
      } catch (error) {
        return false;
      }
    };

    if (
      error.config &&
      error.response &&
      !isIidGoogleApisUrl(error.response.request.responseURL)
    ) {
      const isSupplierUrl = router.currentRoute.path.split("/")[1] === "partners";
      
      if (
        error.response.status === 401 &&
        error.response.config.url.indexOf("retoken") <= 0
      ) {
        let routeName;
        const config = error.config;
        let refreshToken;

        if (isSupplierUrl) {
          routeName = "SupplierLogin";
          refreshToken = localStorage.getItem("supplierRefreshToken");
        } else {
          routeName = "Login";
          const cookieRefreshToken = getCookie(Auth.RefreshToken);
          if (cookieRefreshToken) {
            refreshToken = cookieRefreshToken;
          } else {
            refreshToken = localStorage.getItem("refreshToken");
          }
        }

        return Axios.post(
          `${process.env.HOST}/api/admin/auth/retoken`,
          {
            email: this.email,
            password: this.password
          },
          {
            headers: {
              Authorization: `Bearer ${refreshToken}`
            }
          }
        )
          .then(response => {
            if (response.status === 200) {
              const accessToken = response.data.accessToken.accessToken;
              if (isSupplierUrl) {
                localStorage.setItem(
                  "supplierAccessToken",
                  accessToken
                );
              } else {
                setCookie(Auth.AccessToken, accessToken);
              }
             
              config.headers.Authorization = `Bearer ${accessToken}`;
              baanRueJaiClient.setAuthorizationToken(accessToken);
              return Axios.request(config);
            }
            router.push({
              name: routeName
            });
          })
          .catch(e => {
            router.push({
              name: routeName
            });
          });
      } else if (error.response.status === 403) {
        localStorage.removeItem("adminName");
        localStorage.removeItem("adminRole");
        localStorage.removeItem("adminRolePermission");
        localStorage.removeItem("adminProjects");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        unsetCookie(Auth.AccessToken);
        unsetCookie(Auth.RefreshToken);

        router.push({ name: isSupplierUrl ? "SupplierLogin" : "Login" });
      }
    }

    throw error;
  }
);

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.http.options.emulateJSON = true;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBOb6S8qelddMiLfZQXhBSGozL3-7DNFJA",
    libraries: "places"
  }
});

moment.locale("th");
Vue.filter("moment", text => moment(text).fromNow());
Vue.filter("moment-full", text => moment(text).format("LLL"));
Vue.filter("moment-day-month", text => moment(text).format("D MMMM"));
Vue.filter("moment-time", text => moment(text).format("HH:mm"));
Vue.filter("moment-datetime", text => moment(text).format("D MMM HH:mm"));
Vue.filter("moment-day", text => moment(text).format("D"));
Vue.filter("moment-month", text => moment(text).format("MMM"));
Vue.filter("sentiment-score", text => (text > 3 ? "😡" : "🙂"));
Vue.filter("contact-category", text => {
  if (text === 1) {
    return "พูดคุยสอบถาม";
  }
  return text;
});
Vue.filter("contact_id", text => {
  let output = text.toString();
  if (output.length >= 6) return output;

  while (output.length < 6) {
    output = `0${output}`;
  }
  return `#${output}`;
});
Vue.filter("article-content", text => {
  if (!text) {
    return i18n.tc("feature.article.no_content");
  }
  const obj = JSON.parse(text);
  let output = "";
  obj.forEach(element => {
    output += element.insert;
  });
  return output;
});
Vue.filter("card", text => {
  if (text === "topic") {
    return "/static/icons/topic.svg";
  } else if (text === "event") {
    return "/static/icons/movie.svg";
  } else if (text === "call") {
    return "/static/icons/phone.svg";
  } else if (text === "water") {
    return "/static/icons/water.svg";
  } else if (text === "visitor") {
    return "/static/icons/link.svg";
  } else if (text === "package") {
    return "/static/icons/package.svg";
  }
  return "/static/icons/topic.svg";
});
Vue.filter("correct", text => {
  if (text) {
    return "/static/icons/correct.svg";
  }
  return "/static/icons/wrong.svg";
});
Vue.filter("owner", text => {
  if (text === "owner") {
    return i18n.tc("owner.owner");
  } else if (text === "renter") {
    return i18n.tc("owner.renter");
  } else if (text === "resident") {
    return i18n.tc("owner.resident");
  } else if (text === "contract") {
    return i18n.tc("owner.contract");
  } else if (text === "booking") {
    return i18n.tc("owner.booking");
  }
  return i18n.tc("owner.visitor");
});
Vue.filter("job-no", text => text);

Vue.component("picker", Picker);
Vue.component("Confirm", Confirm);
Vue.directive("click-outside", ClickOutside);

Vue.filter("money", (value, emptyValue) => {
  if (!value && emptyValue !== undefined) {
    return emptyValue;
  }

  return formatToMoney(value);
});

Vue.filter("commas", (value, emptyValue) => {
  if (!value && emptyValue !== undefined) {
    return emptyValue;
  }

  return formatCurrencyAndTwoDecimalsString(value);
});

Vue.filter("date", (value, format = "d/M/yyyy") => {
  if (!value) return "";

  const dateTime = toLocaleTH(DateTime.fromISO(value));

  if (dateTime.invalid) return "-";
  return dateTime.toFormat(format);
});

//fix for el-select
let fixElSelect = function () {
	document.querySelectorAll('.el-select[data-is-search="true"]:hover').forEach((v) => {
		let elInput = document.querySelector('.el-select[data-is-search="true"]:hover input[readonly]');
		if (elInput) {
			elInput.readOnly = false;
			elInput.blur();
			elInput.focus();
		}
	});
};
document.addEventListener("focusin", fixElSelect);
document.addEventListener("click", fixElSelect);
document.addEventListener("touchstart", fixElSelect);
Vue.use(VueTabs);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>",
  store,
  i18n
});



// WEBPACK FOOTER //
// ./src/main.js